"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
var e = require("./defineProperty-b53f90b9.js"),
  t = require("react"),
  r = require("prop-types");
function n(e) {
  return e && "object" == _typeof(e) && "default" in e ? e : {
    "default": e
  };
}
var o = n(t),
  p = n(r);
function u(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function (t) {
      return Object.getOwnPropertyDescriptor(e, t).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function c(t) {
  for (var r = 1; r < arguments.length; r++) {
    var n = null != arguments[r] ? arguments[r] : {};
    r % 2 ? u(Object(n), !0).forEach(function (r) {
      e._defineProperty(t, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : u(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }
  return t;
}
var i = function i(e) {
  var t = e.sx,
    r = e.children,
    n = t || {},
    p = n.pb,
    u = n.pt,
    i = n.mb,
    a = n.mt,
    b = u ? {
      paddingTop: 16 * u
    } : {},
    f = i ? {
      marginBottom: 16 * i
    } : {},
    s = a ? {
      marginTop: 16 * a
    } : {},
    l = c(c(c(c({}, p ? {
      paddingBottom: 16 * p
    } : {}), b), f), s);
  return o["default"].createElement("div", {
    style: l
  }, r);
};
i.propTypes = {
  sx: p["default"].shape({
    pb: p["default"].number,
    pt: p["default"].number,
    mb: p["default"].number,
    mt: p["default"].number
  })
}, i.defaultProps = {
  pb: 0,
  pt: 0,
  mb: 0,
  mt: 0
}, exports.Box = i;